import React, { Component } from 'react';
import { Card, Button, Modal, Col, Form, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
import { Link } from 'react-router-dom';
import { statusSortFunc } from '../../../Helpers/utils.js';
import { FaPhone, FaPhoneAlt, FaClock, FaBan, FaCheckCircle, FaListOl, FaChartBar, FaRedo } from 'react-icons/fa';
import { STATUS_CODE_TO_LABEL, STATUS_MAP, STATUS_PRIORITY, TEMPLATES, THIRTY_SECONDS, USER_ROLES } from '../../../Helpers/constant.js';
import Multiselect from 'multiselect-react-dropdown';
import StatsModal from '../../Dashboard/StatsModal.js';
import { TcdHeaderFormatter } from '../../../Helpers/tooltip.js';
import { switchUser } from '../../../Helpers/switchUser.js';
import FileViewer from '../ViewVoiceBase/FileViewer.js';

class ListVoiceCampaign extends Component {
	constructor(props) {
		super(props);
		const isSadmin = props.app.role === USER_ROLES.S_ADMIN || props.app.role === USER_ROLES.SUB_SUPER_ADMIN;
		this.state = {
			campaignlist: [],
			selectedCampaignId: 0,
			isButtonDisabled: [],
			confirmStop: false,
			confirmPause: false,
			confirmResume: false,
			confirmRetry: false,
			confirmCancel: false,
			confirmComplete: false,
			loading: false,
			showEditChannelModal: false,
			channels: 0,
			campId: 0,
			sizePerPage: 10,
			selectedRows: [],
			filterStatus: [],
			filterUsernames: [],
			showStatModal: false,
			totalReady: 0,
			isWebhookModule: isSadmin,
			WebhookRetryModal: false,
			WebhookRetryCountModal: false,
			isViewBase: false,
			fileViewerUrl: null
		}
		this.interval = null
		this.multiselectRef = React.createRef();
		this.usernameMultiselectRef = React.createRef();
		//<Route path={`${urlPrefix}/campaign-summary`} ><ListCampaign app={props.app} /></Route>
	}
	componentDidMount() {
		this.getCampaigns();
		const savedSizePerPage = Cookies.get('superAdmVoiceCampaignListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
		//every 30 sec
		this.interval = setInterval(() => {
			this.getCampaigns(true);
		}, THIRTY_SECONDS);
	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	getCampaigns = (isAutoRefresh = false) => {
		const userId = this.props.app.userId;
		const userRole = this.props.app.role;
		if (userRole === 'ROLE_ADMIN') {
			Fetcher.get(this.props.app.apiPath + `/api/obd/reseller/campaign/list/${userId}`)
				.then(res => {
					if (!isAutoRefresh) {
						this.setState({
							campaignlist: res,
							confirmStop: false,
							confirmPause: false,
							confirmResume: false,
							confirmRetry: false,
							confirmCancel: false,
						})
					} else {
						this.setState({
							campaignlist: res,
						})
					}
				})
				.catch(err => {
					console.log('Error in fetching Campaigns', err)
					if (this.interval) {
						clearInterval(this.interval);
					}
				});
		} else {
			Fetcher.get(this.props.app.apiPath + '/api/obd/superadmin/campaign/list/' + userId)
				.then(res => {
					if (!isAutoRefresh) {
						this.setState({
							campaignlist: res,
							confirmStop: false,
							confirmPause: false,
							confirmResume: false,
							confirmRetry: false,
							confirmCancel: false,
						})
					} else {
						this.setState({
							campaignlist: res,
						})
					}
				})
				.catch(err => {
					console.log('Error in fetching Campaigns', err)
					if (this.interval) {
						clearInterval(this.interval);
					}
				});
		}
	}

	refreshPage = () => {
		this.setState({ loading: true });
		//window.location.reload();

		setTimeout(() => {
			window.location.reload(false);
		}, 500);
	}

	handleStatusFilter = (selectedList) => {
		const selectedStatuses = selectedList.map(item => item.name);
		this.setState({ filterStatus: selectedStatuses });
	}

	clearStatusFilter = () => {
		if (this.multiselectRef.current) {
			this.multiselectRef.current.resetSelectedValues();
		}
		this.setState({ filterStatus: [] });
	}

	handleUsernameFilter = (selectedList) => {
		const selectedUsernames = selectedList.map(item => item.name);
		this.setState({ filterUsernames: selectedUsernames });
	}

	clearUsernameFilter = () => {
		if (this.usernameMultiselectRef.current) {
			this.usernameMultiselectRef.current.resetSelectedValues();
		}
		this.setState({ filterUsernames: [] });
	}

	downloadReport = (index, campaignId, type) => {
		const data = {
			"campaignId": campaignId,
			"reprtType": type
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/download', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				alert(res.message);
				//document.getElementById('report-' + index).disabled = false;
				//document.getElementById('report-' + index).innerHTML = "Download";
				window.open(this.props.app.reportPath + '/reports/' + campaignId + '.zip', 'Download');
			})
			.catch(err => { console.log('Error in Downloading Report', err) });
	}

	bulkGenerateReport = () => {
		const userId = this.props.app.userId;
		console.log("select ids : " + this.state.selectedRows);

		const idsToFind = this.state.selectedRows;

		const filteredRecords = this.state.campaignlist.filter(record => idsToFind.includes(record.campaignId));

		const totalCallSum = filteredRecords.reduce((sum, record) => sum + record.numbersUploaded, 0);

		console.log("Total Calls : " + totalCallSum);

		if (totalCallSum > 1000000) {

			Notify.notify('Total Numbers Limit cannot exceed 10 Lakhs.');
			this.setState({ reloading: true });

			setTimeout(() => {
				window.location.reload(false);
			}, 2500);
			return;
		}

		const data = {
			"campaignId": 0,
			"reportType": "bulk",
			"campaignIds": this.state.selectedRows.toString(),
			"userId": userId
		};

		console.log("JSON : " + JSON.stringify(data));

		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.setState({ reloading: true });

				setTimeout(() => {
					window.location.reload(false);
				}, 2500);
			})
			.catch(err => { console.log('Error in Generating Report', err) });


	}

	downloadPending = (index, campaignId) => {
		const data = {
			"campaignId": campaignId,
			"reportType": 'pending_data'
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/pending', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				//let csvRows = res.join('\n');
				let csvRows = res.map(item => item.substring(0, 10)).join('\n');
				// Create a Blob and initiate the download
				const blob = new Blob([csvRows], { type: 'text/csv' });
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'pending_data_' + campaignId + '.csv';
				link.click();
			})
			.catch(err => {
				Notify.notify('Something went wrong');
				console.log('Error in Downloading Report', err);
			});
	}

	generateReport = (index, campaignId, reportType) => {
		const userId = this.props.app.userId;
		const data = {
			"campaignId": campaignId,
			"reportType": reportType,
			"userId": userId
		};
		return Fetcher.post(this.props.app.apiPath + '/api/obd/report/generate', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {

				alert(res.message);
				this.getCampaigns();

				//document.getElementById("greport-" + index).disabled = true;
				//document.getElementById('greport-' + index).innerHTML = "Preparing";

			})
			.catch(err => { console.log('Error in Generating Report', err) });
	}

	confirmStop = (status, campaignId) => {
		this.setState({
			confirmStop: status,
			selectedCampaignId: campaignId
		});
	}

	confirmPause = (status, campaignId) => {
		this.setState({
			confirmPause: status,
			selectedCampaignId: campaignId
		});
	}

	confirmResume = (status, campaignId) => {
		this.setState({
			confirmResume: status,
			selectedCampaignId: campaignId
		});
	}

	confirmRetry = (status, campaignId) => {
		this.setState({
			confirmRetry: status,
			selectedCampaignId: campaignId
		});
	}

	confirmCancel = (status, campaignId) => {
		this.setState({
			confirmCancel: status,
			selectedCampaignId: campaignId
		});
	}

	confirmComplete = (status, campaignId) => {
		this.setState({
			confirmComplete: status,
			selectedCampaignId: campaignId
		});
	}

	stopCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/stop', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Stopping', err);
			});
	}

	pauseCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/pause', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Pause', err);
			});
	}

	resumeCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
			userId: this.props.app.userId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/resume', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Resume', err);
			});
	}

	retryCampaign = () => {
		const userId = this.props.app.userId;
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
			userId: userId
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/retry', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Retry', err);
			});
	}

	retryWebhook = () => {
		this.setState({ loading: true });
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/retry/failed/webhook', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();

			})
			.catch(err => {
				console.log('Error in Retry', err);
				// this.setState({ loading: false });
			}).finally(() => this.setState({ loading: false, selectedCampaignId: "", WebhookRetryModal: false }));

	}

	retryWebhookCount = () => {
		this.setState({ loading: true });
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/reset/retry/failed/webhook', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();

			})
			.catch(err => {
				console.log('Error in webhook Retry count', err);
				// this.setState({ loading: false });
			}).finally(() => this.setState({ loading: false, selectedCampaignId: "", WebhookRetryCountModal: false }));
	}

	cancelCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
			status: 7
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/cancel', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Cancel', err);
			});
	}

	completeCampaign = () => {
		const campaignId = this.state.selectedCampaignId;
		const data = {
			campaignId: campaignId,
			status: 2
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/cancel', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getCampaigns();
			})
			.catch(err => {
				console.log('Error in Cancel', err);
			});
	}

	hasSelectedRunningCampaigns = () => {
		const { selectedRows, campaignlist } = this.state;
		return selectedRows.some(campaignId => {
			const campaign = campaignlist.find(c => c.campaignId === campaignId);
			return campaign && campaign.campaignStatus === 1;
		});
	}

	bulkSystemAction = (status) => {
		const { selectedRows } = this.state;

		const data = {
			campaignIds: selectedRows.join(','),
			status: status
		};

		return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/status/change', {
			headers: { "Content-type": "application/json" },
			method: 'POST',
			body: JSON.stringify(data)
		})
			.then(res => {
				if (res.error) return
				const statusText = status === 12 ? 'Cancelled' : 'Completed';
				Notify.notify(res.message ?? `Campaigns successfully marked as ${statusText}`);
				this.getCampaigns();
				this.setState({ selectedRows: [] });
			})
			.catch(err => {
				console.log('Error in bulk system action', err);
				Notify.notify('Error updating campaigns');
			});
	}

	handleSystemCancel = () => {
		this.bulkSystemAction(12); // Status 12 for Cancel
	}

	handleSystemComplete = () => {
		this.bulkSystemAction(11); // Status 11 for Complete
	}

	setMessageShow = (status) => {
		this.setState({
			showEditChannelModal: false,
		});
	}

	closeFileViewer = () => {
		this.setState({ fileViewerUrl: null });
	};

	handleViewBase = async (campaignId) => {
		const apiPath = this.props.app.apiPath;

		const data = {
			startDate: "",
			endDate: "",
			campaignIds: campaignId
		};


		try {
			const res = await Fetcher.post(
				apiPath + '/api/obd/get/voice/base',
				{
					headers: { "Content-type": "application/json" },
					method: 'POST',
					body: JSON.stringify(data)
				}
			);

			const url = Array.isArray(res) ? res[0]?.baseUrl : null
			if (!url) {
				Notify.notify("Url Not found")
				return
			}
			this.setState({
				fileViewerUrl: url,
			});
		} catch (err) {
			Notify.notify("Error opening Base file")
			console.log('Error in fetching Voice Base', err);
		}
	}
	editChannels = (event) => {
		event.preventDefault();
		// const data = {
		// }
		return Fetcher.post(this.props.app.apiPath + '/api/obd/edit/channels/' + this.state.campId + '/' + this.state.channels, { headers: { "Content-type": "application/json" }, method: 'POST' })
			.then(res => {
				if (res.message === 'Parameters Incorrect') {
					Notify.notify('Edit Channels Failed');
				} else {
					Notify.notify(res.message);
				}
				this.refreshPage();
			})
			.catch(err => {
				console.log('Error in Edit Channesl', err)
				Notify.notify('Error in Edit Channels');
			});
	}

	confirmEditChannels = (status, campaignId) => {
		this.setState({
			showEditChannelModal: status,
			campId: campaignId
		});
	}

	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	switchToUser = (userId) => {
		Fetcher.post(this.props.app.apiPath + "/api/obd/switch/user", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ userId: userId }),
		})
			.then((res) => {
				switchUser(res.userid, res.token, res.role);
				if (res.role.includes('ROLE_SUSER')) {
					window.location.href = "/sub-user-report";
				} else {
					window.location.href = "/";
				}
				Notify.notify('User Switch Successfully');
			})
			.catch((err) => {
				console.error("Error while switching user", err);
				Notify.notify("Error while switching user");
			});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('superAdmVoiceCampaignListsizePerPage', newSizePerPage);
	}

	handleSelectAll = (isSelect) => {
		const { campaignlist } = this.state;
		if (isSelect) {
			this.setState({ selectedRows: campaignlist.map(p => p.campaignId) });
		} else {
			this.setState({ selectedRows: [] });
		}
	};

	handleSelectRow = (row, isSelect) => {
		this.setState(prevState => {
			const selectedRows = [...prevState.selectedRows];
			if (isSelect) {
				selectedRows.push(row.campaignId);
			} else {
				const index = selectedRows.indexOf(row.campaignId);
				if (index > -1) {
					selectedRows.splice(index, 1);
				}
			}
			return { selectedRows };
		});
	};

	isSelectedAll = () => {
		const { campaignlist, selectedRows } = this.state;
		return selectedRows.length === campaignlist.length;
	};

	openStatsModal = () => {
		this.setState({ showStatModal: true });
	};

	calculateStats = (campaigns) => {
		return campaigns.reduce(
			(acc, c) => {
				acc.totalNumbers += c.numbersUploaded;
				acc.callsDialed += c.numbersProcessed;
				acc.pendingCalls += c.numbersUploaded - c.dndCount - c.numbersProcessed;
				acc.dndCount += c.dndCount;
				acc.connectedCalls += c.callsConnected;
				acc.retryCount += (c.retryCount || 0);
				acc.totalCallsDialed = acc.callsDialed + acc.retryCount;
				if (c.campaignStatus == 0) {
					acc.totalReady += c.numbersUploaded;
				}
				return acc;
			},
			{
				totalNumbers: 0,
				callsDialed: 0,
				pendingCalls: 0,
				dndCount: 0,
				connectedCalls: 0,
				totalCampaignList: campaigns.length,
				retryCount: 0,
				totalCallsDialed: 0,
				totalReady: 0
			}
		);
	}
	render() {

		const { campaignlist, selectedRows, filterStatus, filterUsernames } = this.state;
		const campaigns = Array.isArray(campaignlist) ? campaignlist : [];

		const uniqueUsernames = [...new Set(campaigns.map(campaign => campaign.username))];
		const usernameOptions = uniqueUsernames.map(username => ({
			id: username,
			name: username
		}));

		const selectedUsernameOptions = usernameOptions.filter(option =>
			this.state.filterUsernames.includes(option.name)
		);
		const filteredCampaigns = campaigns.filter(campaign => {
			const statusFilterMatch = filterStatus.length === 0 || (() => {
				return filterStatus.some(selectedStatus => {
					const statusValue = STATUS_MAP[selectedStatus];
					if (Array.isArray(statusValue)) {
						return statusValue.includes(campaign.campaignStatus);
					}
					return campaign.campaignStatus === statusValue;
				});
			})();

			const usernameFilterMatch = filterUsernames.length === 0 ||
				filterUsernames.includes(campaign.username);

			return statusFilterMatch && usernameFilterMatch;
		});

		const userRole = this.props.app.role;
		let reseller = true;
		if (userRole === 'ROLE_ADMIN') {
			reseller = false;
		}
		const { totalNumbers, callsDialed, pendingCalls, dndCount, connectedCalls, totalCampaignList, totalCallsDialed, retryCount, totalReady } = this.calculateStats(filteredCampaigns);
		const columns = [
			// {
			//      dataField: 'select',
			// 	 csvExport:false,
			//      headerFormatter: (columnProps, colIndex, expandColumnProps) => (
			//     <input
			//           type="checkbox"
			//           checked={this.isSelectedAll()}
			//         onChange={(e) => this.handleSelectAll(e.target.checked)}
			//     />
			//     ),
			//     formatter: (cell, row) => (
			//       <input type="checkbox" checked={selectedRows.includes(row.campaignId)}
			//         onChange={(e) => this.handleSelectRow(row, e.target.checked)} />
			//     ),
			//     headerStyle: { width: '50px'},
			// },
			{
				dataField: 'id',
				text: 'Serial No.',
				sort: false,
				hidden: true,
				csvExport: false
			},
			{
				dataField: 'campaignId',
				text: 'Campaign Id',
				sort: false,
				hidden: false,
				csvExport: true
			},
			{
				dataField: 'campaignName',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				csvExport: false,
				style: { maxWidth: "288px", whiteSpace: 'normal', wordWrap: 'break-word' }
			},
			{
				dataField: 'userId',
				text: 'User Id',
				sort: false,
				hidden: false,
				csvExport: true
			},
			{
				dataField: 'username',
				text: 'User Name',
				sort: true,
				searchable: true,
				csvExport: true,
				formatter: (cell, row) => (
					<span>
						{cell}
						{this.props.app.role === 'ROLE_SADMIN' && (
							<img
								src="/assets/switch-user.png"
								alt="Switch User"
								title="Switch to this user"
								style={{ width: "20px", height: "20px", cursor: "pointer", marginLeft: "6px" }}
								onClick={() => this.switchToUser(row.userId)}
							/>
						)}
					</span>
				)
			},
			{
				dataField: 'parentUsername',
				text: 'Parent Username',
				sort: true,
				searchable: true,
				hidden: reseller,
				csvExport: true
			},
			{
				dataField: 'name',
				text: 'Campaign Name',
				sort: true,
				searchable: true,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'campaignstatus',
				text: 'Campaign Status',
				sort: true,
				searchable: true,
				sortFunc: statusSortFunc
			},
			// {
			// 	dataField: 'channels',
			// 	text: 'Channels',
			// 	sort: true,
			// 	searchable: true
			// },
			{
				dataField: 'templateId',
				text: 'Campaign Type',
				sort: true,
				searchable: true
			}, {
				dataField: 'scheduleTime',
				text: 'Start Time',
				sort: true,
				searchable: false
			}, {
				dataField: 'endTime',
				text: 'End Time',
				sort: true,
				searchable: false
			}, {
				dataField: 'pauseTime',
				text: 'Pause Time',
				sort: true,
				searchable: false
			}, {
				dataField: 'numbersUploaded',
				text: 'Total Numbers',
				sort: false,
				searchable: false,
				formatter: (cell, row, rowIndex, extraData) => (
					<div>{row.numbersUploaded} {this.props.app.role === "ROLE_SADMIN" && row.continuous === 0 && <Button size='sm' title='View Base' onClick={() => this.handleViewBase(row.campaignId)}><i className="fa fa-eye" /></Button>}</div>
				),

			},
			{
				dataField: 'totalCallsDialed',
				text: 'TCD',
				headerFormatter: () => (
					<TcdHeaderFormatter
						id="tcd-tooltip"
						text="TCD"
						tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
					/>),
				sort: false,
				searchable: false,
				headerStyle: { minWidth: "90px" }
			}, {
				dataField: 'numbersProcessed',
				text: 'Calls Dialed',
				sort: false,
				searchable: false
			}, {
				dataField: 'callsSubmitted',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'callsSubmittedCsv',
				text: 'Pending Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'callsConnected',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'callsConnectedCsv',
				text: 'Connected Calls',
				sort: false,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'pulses',
				text: 'Total Pulses',
				sort: true,
				searchable: false
			}, {
				dataField: 'dndCount',
				text: 'DnD Count',
				sort: true,
				searchable: false
			}, {
				dataField: 'dtmfCount',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'dtmf1Count',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'dtmf2Count',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				csvExport: false
			}, {
				dataField: 'webhookFailedCount',
				text: 'Webhook Failed Count',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: false
			}, {
				dataField: 'webhookFailedCountCsv',
				text: 'Webhook Failed Count',
				hidden: true,
				csvExport: this.state.isWebhookModule
			}, {
				dataField: 'webhookLog',
				text: 'Webhook Log',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: this.state.isWebhookModule
			}, {
				dataField: 'webhookSuccessCount',
				text: 'Webhook Success Count',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: this.state.isWebhookModule
			}, {
				dataField: 'retryWebhookCountOriginal',
				text: 'Webhook Retry Count',
				hidden: true,
				csvExport: this.state.isWebhookModule
			}, {
				dataField: 'retryWebhookCount',
				text: 'Webhook Retry Count',
				sort: true,
				searchable: false,
				hidden: !this.state.isWebhookModule,
				csvExport: false
			}, {
				dataField: 'dtmfCountCsv',
				text: 'Dtmf Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'dtmf1CountCsv',
				text: 'Dtmf1 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'dtmf2CountCsv',
				text: 'Dtmf2 Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'smsCount',
				text: 'SMS Count',
				sort: true,
				searchable: false
			}, {
				dataField: 'smsCountCsv',
				text: 'SMS Count',
				sort: true,
				searchable: false,
				hidden: true,
				csvExport: true
			}, {
				dataField: 'retryCount',
				text: 'Retry Count',
				sort: true,
				searchable: false
			}, {
				dataField: 'retries',
				text: 'Is Retry',
				sort: true,
				searchable: false,
				hidden: true
			},
			{
				dataField: 'ttsCount',
				text: 'Total Variable Count',
				sort: true,
				searchable: false,
				csvExport: true
			},
			{
				dataField: 'retries',
				text: 'No. Of retries',
				sort: true,
				searchable: false
			}, {
				dataField: 'fullReportStatus',
				text: 'Action',
				sort: false,
				searchable: false,
				csvExport: false
			}];

		const products = Array.isArray(filteredCampaigns) ? filteredCampaigns.map((campaign, index) => {
			const template = TEMPLATES[campaign.templateId] ?? ""
			const status = STATUS_CODE_TO_LABEL[campaign.campaignStatus] ?? '';

			let action = [];
			let retry = [];
			//let 
			action.push(<Dropdown id="dd">
				<Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
				<Dropdown.Menu>
					{/* <Dropdown.Item key={`clone-campaign-${index}`} href={`${this.props.app.urlPrefix}/clone-campaign/${campaign.campaignId}`}>Clone Campaign</Dropdown.Item> */}
					{(campaign.campaignStatus === 1) && <Dropdown.Item key={`ps-campaign-${index}`} onClick={() => this.confirmPause(true, campaign.campaignId)} href="#">Pause Campaign</Dropdown.Item>}
					{(campaign.campaignStatus === 3 || campaign.campaignStatus === 9) && <Dropdown.Item key={`rs-campaign-${index}`} onClick={() => this.confirmResume(true, campaign.campaignId)} href="#">Resume Campaign</Dropdown.Item>}
					{/* {(campaign.campaignStatus === 1) && <Dropdown.Item key={`st-campaign-${index}`} onClick={() => this.confirmStop(true, campaign.campaignId)} href="#">Stop Campaign</Dropdown.Item>} */}
					{(campaign.campaignStatus === 1) && <Dropdown.Item key={`st-campaign-${index}`} onClick={() => this.confirmStop(true, campaign.campaignId)} href="#">Stop Campaign</Dropdown.Item>}
					{(campaign.campaignStatus === 3 || campaign.campaignStatus === 4 || campaign.campaignStatus === 5) && <Dropdown.Item key={`cn-campaign-${index}`} onClick={() => this.confirmCancel(true, campaign.campaignId)} href="#">Cancel Campaign</Dropdown.Item>}
					{(campaign.campaignStatus === 3 || campaign.campaignStatus === 4 || campaign.campaignStatus === 5) && <Dropdown.Item key={`complete-campaign-${index}`} onClick={() => this.confirmComplete(true, campaign.campaignId)} href="#">Complete Campaign</Dropdown.Item>}
					{/* {(campaign.campaignStatus === 9) && <Dropdown.Item key={`edit-campaign-${index}`} onClick={() => this.confirmEditChannels(true, campaign.campaignId)} href="#">Edit Channels</Dropdown.Item>} */}
					{(campaign.fullReportStatus === '2' || campaign.fullReportStatus === undefined) && <Dropdown.Item id={`greport-full-${index}`} key={`greport-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'full')} href="#">Generate Full Report</Dropdown.Item>}
					{(campaign.webhookLog === '1') && <Dropdown.Item id={`greport-webhook-${index}`} key={`greport-webhook-${index}`} onClick={() => this.generateReport(index, campaign.campaignId, 'webhook')} href="#">Generate Webhook Report</Dropdown.Item>}

				</Dropdown.Menu>
			</Dropdown>);
			// if(campaign.campaignStatus === 2 && campaign.isRetry === 0)
			// {
			// 	retry.push(<Link data-tip="Retry" key={`${index}-retry`} className="btn btn-sm btn-primary" onClick={(e) => { this.confirmRetry(true, campaign.campaignId) }} href="#">Retry</Link>);
			// }
			let callsSubmitted = 0;
			let dtmfDownload = [];
			dtmfDownload.push(campaign.dtmfCount);
			dtmfDownload.push(' ');
			if (campaign.templateId === 1 || campaign.templateId === 2 || campaign.templateId === 3 || campaign.templateId === 4) {
				if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
					dtmfDownload.push(<a data-tip="" key={`${index}-dtmf`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf') }} href="#"><i className="fa fa-download"></i></a>);
				}
			}
			let dtmf1Download = [];
			dtmf1Download.push(campaign.dtmf1Count);
			dtmf1Download.push(' ');
			if (campaign.templateId === 3 || campaign.templateId === 4) {
				if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
					dtmf1Download.push(<a data-tip="" key={`${index}-dtmf1`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf1') }} href="#"><i className="fa fa-download"></i></a>);
				}
			}
			let dtmf2Download = [];
			dtmf2Download.push(campaign.dtmf2Count);
			dtmf2Download.push(' ');
			if (campaign.templateId === 3 || campaign.templateId === 4) {
				if (campaign.dtmfReportStatus === '2' || campaign.dtmfReportStatus === undefined) {
					dtmf2Download.push(<a data-tip="" key={`${index}-dtmf2`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'dtmf2') }} href="#"><i className="fa fa-download"></i></a>);
				}
			}

			let ccDownload = [];
			ccDownload.push(campaign.callsConnected);
			ccDownload.push(' ');
			if (campaign.callsConnected > 0) {
				if (campaign.ccReportStatus === '2' || campaign.ccReportStatus === undefined) {
					ccDownload.push(<a data-tip="" key={`${index}`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'connected_calls') }} href="#"><i className="fa fa-download"></i></a>);
				}
			}
			let ccPending = [];
			ccPending.push(campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed);
			ccDownload.push(' ');
			ccPending.push(<a data-tip="" key={`${index}-pending`} className="download-report" onClick={(e) => { this.downloadPending(true, campaign.campaignId) }} href="#"><i className="fa fa-download"></i></a>);

			let smsDownload = [];
			smsDownload.push(campaign.smsCount);
			smsDownload.push(' ');
			if (campaign.smsCount > 0) {
				if (campaign.smsStatus == 2 || campaign.smsStatus == undefined) {
					smsDownload.push(<a data-tip="" key={`${index}-sms`} className="download-report" onClick={(e) => { this.generateReport(true, campaign.campaignId, 'sms') }} href="#"><i className="fa fa-download"></i></a>);
				}
			}

			let webhookFailedCount = Number(campaign.webhookFailedCount) || 0;
			let retryWebhookCount = Number(campaign.retryWebhookCount) || 0;

			if (webhookFailedCount > 0) {
				const currentDate = new Date();
				const scheduleDate = new Date(
					campaign.scheduleTime.replace(" ", "T")
				);
				const diffTime = currentDate - scheduleDate;
				const diffDays = Math.floor(
					(diffTime) / (1000 * 60 * 60 * 24)
				);
				// console.log({diffDays,retryWebhookCount,scheduleTime:campaign.scheduleTime})
				if (diffDays <= 2 && retryWebhookCount <= 2) {
					webhookFailedCount = <span key={`${index}-retry-cm`}  >{webhookFailedCount}<a href="#" className="download-report" style={{ margin: "4px" }} onClick={() => { this.setState({ selectedCampaignId: campaign.campaignId, WebhookRetryModal: true }) }}><i className="fa fa-repeat"></i></a></span>
				}
			}
			if (retryWebhookCount === 2) {
				retryWebhookCount = <span key={`${index}-retry-webhook-cm`}  >{retryWebhookCount}<a href="#" className="download-report" style={{ margin: "4px" }} onClick={() => { this.setState({ selectedCampaignId: campaign.campaignId, WebhookRetryCountModal: true }) }}><i className="fa fa-cog"></i></a></span>
			}
			return {
				id: index + 1,
				campaignId: campaign.campaignId,
				name: campaign.campaignName,
				userId: campaign.userId,
				username: campaign.username,
				campaignName: ([0, 1, 2, 3, 7, 8, 9].includes(campaign.templateId)) ? <Link key={`${index}-cm`} to={`${this.props.app.urlPrefix}/voice-campaign-info/${campaign.campaignId}`}>{campaign.campaignName}</Link> : campaign.campaignName,
				campaignstatus: status,
				// channels: campaign.channels,
				templateId: template,
				scheduleTime: campaign.scheduleTime,
				endTime: campaign.endTime,
				pauseTime: campaign.pauseTime,
				parentUsername: campaign.parentUsername,
				numbersUploaded: campaign.numbersUploaded,
				numbersProcessed: campaign.numbersProcessed,
				callsSubmitted: (campaign.campaignStatus === 7 || campaign.campaignStatus === 9) ? ccPending : campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
				callsSubmittedCsv: campaign.numbersUploaded - campaign.dndCount - campaign.numbersProcessed,
				callsConnected: (campaign.campaignStatus === 2) ? ccDownload : campaign.callsConnected,
				callsConnectedCsv: campaign.callsConnected,
				continuous: campaign.continuous,
				pulses: campaign.pulses,
				dndCount: campaign.dndCount,
				dtmfCount: (campaign.campaignStatus === 2) ? dtmfDownload : campaign.dtmfCount,
				dtmf1Count: (campaign.campaignStatus === 2) ? dtmf1Download : campaign.dtmf1Count,
				dtmf2Count: (campaign.campaignStatus === 2) ? dtmf2Download : campaign.dtmf2Count,
				dtmfCountCsv: campaign.dtmfCount,
				dtmf1CountCsv: campaign.dtmf1Count,
				dtmf2CountCsv: campaign.dtmf2Count,
				smsCount: (campaign.campaignStatus === 2) ? smsDownload : campaign.smsCount,
				smsCountCsv: campaign.smsCount,
				retryCount: campaign.retryCount,
				retries: (campaign.retries > 0) ? 'Yes' : 'No',
				retries: campaign.retries,
				fullReportStatus: action,
				ttsCount: campaign.ttsCount,
				totalCallsDialed: (campaign.numbersProcessed + (campaign.retryCount || 0)),
				webhookSuccessCount: (campaign.webhookSuccessCount ?? 0),
				webhookLog: (campaign.webhookLog ?? 0),
				webhookFailedCount: webhookFailedCount,
				retryWebhookCount: retryWebhookCount,
				retryWebhookCountOriginal: campaign.retryWebhookCount,
				webhookFailedCountCsv: Number(campaign.webhookFailedCount) || 0
			};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;
		const { ExportCSVButton } = CSVExport;

		const defaultSorted = [{
			dataField: 'campaignstatus',
			order: 'asc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: products.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		const selectRow = {
			mode: 'checkbox',
			clickToSelect: false,
			selected: this.state.selectedRows,
			onSelect: (row, isSelect) => {
				if (isSelect) {
					this.setState(prev => ({
						selectedRows: [...prev.selectedRows, row.campaignId]
					}));
				} else {
					this.setState(prev => ({
						selectedRows: prev.selectedRows.filter(id => id !== row.campaignId)
					}));
				}
			},
			onSelectAll: (isSelect, rows) => {
				if (isSelect) {
					const allIds = rows.map(cli => cli.campaignId);
					this.setState({ selectedRows: allIds });
				} else {
					this.setState({ selectedRows: [] });
				}
			},
			selectColumnStyle: { paddingLeft: '12px' },
			headerColumnStyle: { paddingLeft: '12px' },
		};

		const filterTime = (date) => {
			const isPastTime = new Date().getTime() > date.getTime();
			return !isPastTime;
		};

		const statusOptions = Object.keys(STATUS_PRIORITY).sort((a, b) => STATUS_PRIORITY[a] - STATUS_PRIORITY[b]);
		const statusOptionsForMultiselect = statusOptions.map(status => ({
			id: status,
			name: status
		}));

		const selectedStatusOptions = statusOptionsForMultiselect.filter(option =>
			this.state.filterStatus.includes(option.name)
		);
		return (
			<Card>
				<Card.Header>Voice Campaign Summary</Card.Header>
				<Card.Body>
					<div className="campaign-list-table-cont">
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.campaignlist ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{({
								paginationProps, paginationTableProps
							}) => (<ToolkitProvider
								keyField="campaignId"
								data={products}
								columns={columns}
								search
								bootstrap4
								exportCSV={{
									fileName: 'campaign_summary.csv'
								}}
							>
								{props => (
									<div>
										<Row className="align-items-center mb-3 g-2">
											<Col md="auto">
												Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
											</Col>

											<Col md="auto">
												<span className="search-cont">
													<SearchBar {...props.searchProps} />
												</span>
											</Col>

											<Col md="auto">
												<ClearSearchButton className="btn-primary" {...props.searchProps} />
											</Col>

											<Col className="d-flex align-items-center ms-auto" md="auto">
												<ExportCSVButton className="export-csv btn-primary me-2" {...props.csvProps}>
													Export to CSV
												</ExportCSVButton>

												<Button className="btn btn-primary" onClick={() => this.refreshPage()}>
													Refresh
												</Button>
											</Col>

											{this.state.selectedRows.length > 0 && (
												<Col md="auto">
													<Button className="btn btn-primary" onClick={() => this.bulkGenerateReport()}>
														Generate Bulk Report
													</Button>
												</Col>
											)}

										</Row>
										<Row className='mb-3 align-items-center'>
											<Col md="auto">
												<h6 className="mb-0" style={{ fontWeight: 600, color: '#333', whiteSpace: 'nowrap' }}>
													Filters:
												</h6>
											</Col>
											<Col md="auto">
												<div className={"status-multiselect-container " + (selectedStatusOptions.length > 0 ? "show-placeholder-style" : "")}>
													<Multiselect
														ref={this.multiselectRef}
														options={statusOptionsForMultiselect}
														selectedValues={selectedStatusOptions}
														onSelect={this.handleStatusFilter}
														onRemove={this.handleStatusFilter}
														displayValue="name"
														closeOnSelect={false}
														avoidHighlightFirstOption={true}
														placeholder={selectedStatusOptions.length > 0
															? `${selectedStatusOptions.length} Selected`
															: "Select Status"
														}
														showCheckbox={true}
														hideSelectedList
														style={{
															multiselectContainer: {
																maxWidth: '300px'
															},
															searchBox: {
																border: '1px solid #ced4da',
																borderRadius: '4px',
																minHeight: '38px',
																maxHeight: '43px',
																padding: '5px 14px',
																overflowY: 'auto',
																overflowX: 'hidden'
															},
															option: {
																color: 'black',
																background: 'white'
															},
															optionContainer: {
																borderRadius: '4px',
																boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
																maxHeight: '250px',
																overflowY: 'auto'
															}
														}}
													/>
													{this.state.filterStatus.length > 0 && (
														<Button
															variant="link"
															className="p-0 ms-2 text-decoration-none"
															onClick={this.clearStatusFilter}
														>
															Clear
														</Button>
													)}
												</div>
											</Col>
											{/* Add Username Filter */}
											<Col md="auto">
												<div className={"username-multiselect-container " + (selectedUsernameOptions.length > 0 ? "show-placeholder-style" : "")}>
													<Multiselect
														ref={this.usernameMultiselectRef}
														options={usernameOptions}
														selectedValues={selectedUsernameOptions}
														onSelect={this.handleUsernameFilter}
														onRemove={this.handleUsernameFilter}
														displayValue="name"
														closeOnSelect={false}
														avoidHighlightFirstOption={true}
														placeholder={selectedUsernameOptions.length > 0
															? `${selectedUsernameOptions.length} Selected`
															: "Select Username"
														}
														showCheckbox={true}
														hideSelectedList
														style={{
															multiselectContainer: {
																maxWidth: '300px'
															},
															searchBox: {
																border: '1px solid #ced4da',
																borderRadius: '4px',
																minHeight: '38px',
																maxHeight: '43px',
																padding: '5px 14px',
																overflowY: 'auto',
																overflowX: 'hidden'
															},
															option: {
																color: 'black',
																background: 'white'
															},
															optionContainer: {
																borderRadius: '4px',
																boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
																maxHeight: '250px',
																overflowY: 'auto'
															}
														}}
													/>
													{this.state.filterUsernames.length > 0 && (
														<Button
															variant="link"
															className="p-0 ms-2 text-decoration-none"
															onClick={this.clearUsernameFilter}
														>
															Clear
														</Button>
													)}
												</div>
											</Col>

											{/* Buttons at the end */}
											<Col className="ms-auto text-end">
												{this.state.selectedRows.length > 0 && !this.hasSelectedRunningCampaigns() && (
													<>
														<Button
															variant="primary"
															className="me-2"
															onClick={this.handleSystemCancel}
														>
															System Cancel
														</Button>
														<Button
															variant="primary"
															onClick={this.handleSystemComplete}
														>
															System Complete
														</Button>
													</>
												)}
											</Col>
										</Row>
										<Row className="mb-3 w-100" style={{ gap: '16px' }}>
											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #007bff', color: '#007bff', cursor: 'pointer' }}>
													<FaListOl className="pill-icon" />
													Total: {totalNumbers.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #17a2b8', color: '#17a2b8', cursor: 'pointer' }}>
													<FaChartBar className="pill-icon" />
													Total Campaign: {totalCampaignList.toLocaleString()}
												</div>
											</Col>
											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #28a745', color: '#28a745', cursor: 'pointer' }}>
													<FaPhoneAlt className="pill-icon" />
													Dialed: {callsDialed.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #6f42c1', color: '#6f42c1', cursor: 'pointer' }}>
													<FaClock className="pill-icon" />
													Pending: {pendingCalls.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #dc3545', color: '#dc3545', cursor: 'pointer' }}>
													<FaBan className="pill-icon" />
													DnD: {dndCount.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #28a745', color: '#28a745', cursor: 'pointer' }}>
													<FaCheckCircle className="pill-icon" />
													Connected: {connectedCalls.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #fd7e14', color: '#fd7e14', cursor: 'pointer' }}>
													<FaChartBar className="pill-icon" />
													Total Calls Dialed: {totalCallsDialed.toLocaleString()}
												</div>
											</Col>

											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #6610f2', color: '#6610f2', cursor: 'pointer' }}>
													<FaRedo className="pill-icon" />
													Retry Count: {retryCount.toLocaleString()}
												</div>
											</Col>
											<Col onClick={this.openStatsModal}>
												<div className="stat-pill" style={{ border: '2px solid #17a2b8', color: '#17a2b8', cursor: 'pointer' }}>
													<FaChartBar className="pill-icon" />
													Total Ready: {totalReady.toLocaleString()}
												</div>
											</Col>
										</Row>

										<BootstrapTable
											bordered={true}
											hover
											defaultSorted={defaultSorted}
											wrapperClasses="table-responsive"
											classes="w-auto campaignlist-table"
											{...props.baseProps}
											{...paginationTableProps}
											noDataIndication={() => <div>No data available</div>}
											selectRow={selectRow}
										/>

										<PaginationListStandalone {...paginationProps} />
									</div>
								)}

							</ToolkitProvider>)}
						</PaginationProvider>}
					</div>
					<Modal size="md" show={this.state.confirmStop} onHide={() => this.confirmStop(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Stop Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to stop this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmStop(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.stopCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.WebhookRetryModal} onHide={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Rerty Webhook Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to retry webhook for this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.setState({ selectedCampaignId: "", WebhookRetryModal: false })} variant="secondary">CANCEL</Button>
							<Button onClick={this.retryWebhook} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					<Modal size="md" show={this.state.confirmPause} onHide={() => this.confirmPause(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Pause Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to pause this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmPause(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.pauseCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmResume} onHide={() => this.confirmResume(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Resume Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to resume this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmResume(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.resumeCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmRetry} onHide={() => this.confirmRetry(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Retry Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to retry this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmRetry(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.retryCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					<Modal size="md" show={this.state.WebhookRetryCountModal} onHide={() => this.setState({ selectedCampaignId: "", WebhookRetryCountModal: false })}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Reset Webhook Count
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to reset webhook rerty count for this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.setState({ selectedCampaignId: "", WebhookRetryCountModal: false })} variant="secondary">CANCEL</Button>
							<Button onClick={this.retryWebhookCount} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>
					<Modal size="md" show={this.state.confirmCancel} onHide={() => this.confirmCancel(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Cancel Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to Cancel this campaign?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmCancel(false, '')} variant="secondary">NO</Button>
							<Button onClick={this.cancelCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.confirmComplete} onHide={() => this.confirmComplete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Complete Campaign
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to mark this campaign as complete?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmComplete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.completeCampaign} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

					<Modal size="md" show={this.state.showEditChannelModal} onHide={() => this.setMessageShow(false)}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Edit Channels
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Form method="post" onSubmit={this.editChannels}>
								<Row>
									<Col sm={6}>
										<Form.Group>
											<Form.Control required name="channels" type="number" placeholder="Channels" onChange={e => this.setvalue(e)} value={this.state.channels} />
										</Form.Group>
									</Col>
								</Row>
								<Button variant="primary" type="submit">Edit Channels</Button>
							</Form>
						</Modal.Body>
					</Modal>
					<StatsModal
						show={this.state.showStatModal}
						onHide={() => this.setState({ showStatModal: false })}
						totalNumbers={totalNumbers}
						totalCampaignList={totalCampaignList}
						callsDialed={callsDialed}
						pendingCalls={pendingCalls}
						dndCount={dndCount}
						connectedCalls={connectedCalls}
						totalCallsDialed={totalCallsDialed}
						retryCount={retryCount}
						totalReady={totalReady}
					/>

					{(this.state.loading === true) && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
				</Card.Body>
				{this.state.fileViewerUrl && (
					<FileViewer
						url={this.state.fileViewerUrl}
						onClose={this.closeFileViewer}
					/>
				)}

			</Card>
		);
	}
}


export default ListVoiceCampaign;